import React from 'react';
import { useTranslation } from 'react-i18next';

import { InputHandler } from '../../../../../viewer/input-handler';
import { SelectTool } from '../../../../../viewer/tools/select-tool';
import { SkyviewContext } from '../../../skyview/skyview-state';
import { ToolIcon } from '../tool-icon';

const SelectToolIcon = () => {
  const { t } = useTranslation();
  const { activeTool } = React.useContext(SkyviewContext);

  return (
    <ToolIcon
      active={activeTool instanceof SelectTool}
      callback={() => {
        InputHandler.instance.setTool('select');
      }}
      icon={['fal', 'hand']}
      tooltip={{
        title: t('select.tooltip.title', { ns: 'skyviewToolbar' }),
        text: t('select.tooltip.text', { ns: 'skyviewToolbar' }),
      }}
    />
  );
};

export { SelectToolIcon };
